import type { MouseEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { logoutUser } from "../features/login/login-slice";
import { clearUrl } from "../features/web/web-slice";
import { logout } from "../firebase";

function LoginDashboard() {
	const name = useAppSelector((state) => state.login.username);
	const isAuth = useAppSelector((state) => state.login.isAuth);

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const handleLogout = async (event: MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		await logout();
		dispatch(logoutUser());
		dispatch(clearUrl());
		navigate("/");
	};

	return (
		<div className="navbar__actions">
			{isAuth ? (
				<>
					<span className="navbar__user">{name || "Cuenta"}</span>
					<button className="button button--ghost" onClick={handleLogout}>
						Cerrar sesión
					</button>
				</>
			) : (
				<>
					<Link to="/register" className="button button--ghost">
						Crear cuenta
					</Link>
					<Link to="/login" className="button button--primary">
						Iniciar sesión
					</Link>
				</>
			)}
		</div>
	);
}
export default LoginDashboard;
